module.exports = __webpack_public_path__ + "static/media/Map B.25b0d8c5.png";